module.exports = __webpack_public_path__ + "vue/img/regions-ru.395dab38.svg";